import { useState } from "react";
import { Radio } from "shared/components";
import { BaseInput } from "shared/components/forms/BaseInput";
import { type CredentialFormProps } from "./types";

export const PropertywareCredentialForm = ({
  register
}: CredentialFormProps) => {
  const [isEnterprise, setIsEnterprise] = useState(false);

  return (
    <>
      <div className="flex gap-4">
        <Radio
          id="propertyware_tier_standard"
          name="propertyware_tier"
          checked={!isEnterprise}
          onChange={() => setIsEnterprise(false)}
          label="Standard"
          className="text-sm"
        />
        <Radio
          id="propertyware_tier_enterprise"
          name="propertyware_tier"
          checked={isEnterprise}
          onChange={() => setIsEnterprise(true)}
          label="Enterprise"
          className="text-sm"
        />
      </div>

      <BaseInput
        id="propertyware_client_id"
        label="Client ID"
        {...register("propertyware_client_id")}
        required
      />
      <BaseInput
        id="propertyware_client_secret"
        label="Client Secret"
        {...register("propertyware_client_secret")}
        required
      />
      <BaseInput
        id="propertyware_system_id"
        label="System ID"
        {...register("propertyware_system_id")}
        required
      />

      {isEnterprise && (
        <BaseInput
          id="propertyware_market_id"
          label="Market ID"
          {...register("propertyware_market_id")}
          required
        />
      )}
    </>
  );
};
